import type { ProgressStatus, ProgressSize } from './progressBar.types';

export const STATUS_COLORS = {
  on_track: 'bg-green-500',
  at_risk: 'bg-yellow-500',
  off_track: 'bg-red-500',
} as const;

export const SIZE_CONFIG = {
  sm: {
    height: 'h-1.5',
    fontSize: 'text-xs',
  },
  md: {
    height: 'h-2.5',
    fontSize: 'text-sm',
  },
  lg: {
    height: 'h-4',
    fontSize: 'text-base',
  },
} as const;

export function getStatusColor(status?: ProgressStatus): string {
  return status ? STATUS_COLORS[status] : 'bg-blue-500';
}

export function getSizeConfig(size: ProgressSize) {
  return SIZE_CONFIG[size];
}

/**
 * Normaliza o progresso para exibição do número
 * Apenas previne valores negativos, permite > 100%
 */
export function normalizeProgress(progress: number): number {
  return Math.max(progress, 0);
}

/**
 * Normaliza o progresso para largura da barra visual
 * Limita entre 0-100% para a barra não exceder o container
 */
export function normalizeBarWidth(progress: number): number {
  return Math.min(Math.max(progress, 0), 100);
}
